export enum WhitelistDirectionEnum {
  read = 1,
  write = 2,
  all = 3
}
